import { render, staticRenderFns } from "./LaboralRequestTable.vue?vue&type=template&id=5be14f3b&"
import script from "./LaboralRequestTable.vue?vue&type=script&lang=js&"
export * from "./LaboralRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./LaboralRequestTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports